import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
    isLoading: false,
    isDocumentsLoading: false,
    isDocumentLoading: false,
    isDocumentTypesLoading: false,
    error: null,
    documents: null,
    documentTypes: null,
};

const slice = createSlice({
    name: 'document',
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isLoading = true;
        },
        startDocumentLoading(state) {
            state.isTagsLoading = true;
        },
        startDocumentsLoading(state) {
            state.isDocumentsLoading = true;
        },
        startDocumentTypesLoading(state) {
            state.isDocumentTypesLoading = true;
        },
        // HAS ERROR
        hasError(state, action) {
            state.isDocumentLoading = false;
            state.isDocumentTypesLoading = false;
            state.error = action.payload;
        },
        // GET DOCUMENTTYPES
        setDocumentTypes(state, action) {
            state.isDocumentTypesLoading = false;
            state.documentTypes = action.payload;
        },

        // GET DOCUMENTS
        setDocuments(state, action) {
            state.isDocumentsLoading = false;
            state.documents = action.payload;
        }
    },
});

// Reducer
export default slice.reducer;

// Actions
export const {
    startLoading,
    startDocumentLoading,
    startDocumentTypesLoading,
    hasError,
} = slice.actions;

// ----------------------------------------------------------------------


export function getDocumentTypes() {
    return async () => {
        dispatch(slice.actions.startDocumentTypesLoading());
        try {
            const response = await axios.get(`/admin/document/document_types`);
            dispatch(slice.actions.setDocumentTypes(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getDocument(params = {}) {
    return async () => {
        dispatch(slice.actions.startDocumentsLoading());
        try {
            const response = await axios.get(`/dropdown/document/documents`, { params });
            dispatch(slice.actions.setDocuments(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getAvailableDocument() {
    return async () => {
        dispatch(slice.actions.startDocumentsLoading());
        try {
            const response = await axios.get(`/dropdown/document/available_documents`);
            dispatch(slice.actions.setDocuments(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}